// It shows only targetElement in a group of elements
export const toggleShow = (elements, targetElement, hiddenClass = 'visually-hidden') => {
  elements.forEach((element) => {
    element.classList.add(hiddenClass);

    if (element === targetElement) {
      element.classList.remove(hiddenClass);
    }
  });
};

export const humanFileSize = (size) => {
  const pow = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return `${(size / 1024 ** pow).toFixed(2) * 1} ${['Bytes', 'KB', 'MB', 'GB', 'TB'][pow]}`;
};

export const toggleActive = (elements, targetElement, activeClass = 'active') => {
  elements.forEach((element) => {
    element.classList.remove(activeClass);

    if (element === targetElement) {
      element.classList.add(activeClass);
    }
  });
};

export const hideElement = (element, hiddenClass = 'visually-hidden') => {
  if (!element) {
    return;
  }
  element.classList.add(hiddenClass);
};

export const showElement = (element, hiddenClass = 'visually-hidden') => {
  if (!element) {
    return;
  }
  element.classList.remove(hiddenClass);
};
